import AwaitingChatDialog from '@components/AwaitingChatDialog';
import AgentChatManager from '@logic/agentchatmanager';
import { Box, makeStyles, useMediaQuery } from '@material-ui/core';
import {
  selectChatContextMenuOption,
  toggleChatContextMenu,
} from '@src/actions/agentconsole';
import { Header } from '@src/components/Common/Header';
import ConnectionLostAlert from '@src/components/ConnectionLostAlert/ConnectionLostAlert';
import { appConfig } from '@src/config/appConfig';
import useCocoScript from '@src/hooks/useCocoScript';
import { getUserApplicableSettings } from '@src/reducers/chatAutoAssignment';
import {
  activeConsoleWindow,
  fetchStartConsole,
  inactiveConsoleWindow,
} from '@src/reducers/chats';
import { selectAuthenticationInfo } from '@src/selectors/user';
import { RootState } from '@src/store/reduxstore';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChatTraysSection from '../ChatTraysSection';
import ContactSection from '../ContactSection';
import SideMenuWrapper from '../SideMenu';
import TimelineSection from '../TimelineSection';
import {
  CONTACT_AND_HEADER_TIGHT_WIDTH,
  CONTACT_AND_HEADER_WIDTH,
  LAYOUT_PADDING_WIDTH,
} from './Utils';

const headerContactContainerWidth =
  CONTACT_AND_HEADER_WIDTH + LAYOUT_PADDING_WIDTH * 1.5;
const headerContactContainerWidthTight =
  CONTACT_AND_HEADER_TIGHT_WIDTH + LAYOUT_PADDING_WIDTH * 1.5;

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    width: '100%',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.background.default
        : theme.b2chatgray[100],
    display: 'flex',
    overflow: 'clip',
  },
  headerContactContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: `${headerContactContainerWidth}px`,
    padding: `${LAYOUT_PADDING_WIDTH}px 0px ${LAYOUT_PADDING_WIDTH}px 0`,
  },
  contactSideMenuContainer: {
    height: 'calc(100vh - 88px)',
    display: 'flex',
    paddingTop: `${LAYOUT_PADDING_WIDTH}px`,
    paddingRight: '0px',
  },
}));

const Layout: React.FC = () => {
  const dispatch = useDispatch();

  useCocoScript();

  const currentUser = useSelector(selectAuthenticationInfo);

  const { isOpened, selectedOption } = useSelector(
    (state: RootState) => state.agentConsole.chatContextMenu
  );
  const { currentContactChatHistory } = useSelector(
    (state: RootState) => state.agentConsole
  );

  const isContextMenuOpened = useSelector(
    (state: RootState) => state.agentConsole.chatContextMenu.isOpened
  );

  const isMaxWidth = useMediaQuery(
    `(max-width:${appConfig.maxWidthConsole}px)`
  );

  useEffect(() => {
    AgentChatManager.setCurrentLoggedInUser(currentUser);
    AgentChatManager.connectWebsockets();
    dispatch(fetchStartConsole());
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dispatch(getUserApplicableSettings());
    dispatch(activeConsoleWindow());

    return () => {
      dispatch(inactiveConsoleWindow());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { container, headerContactContainer, contactSideMenuContainer } =
    useStyles();

  return (
    <>
      <ConnectionLostAlert />
      <AwaitingChatDialog />
      <Box className={container}>
        <ChatTraysSection />
        <TimelineSection />
        <Box
          className={headerContactContainer}
          width={
            isContextMenuOpened && !isMaxWidth
              ? `${headerContactContainerWidth}px`
              : `${headerContactContainerWidthTight}px`
          }
        >
          <Box mr={`${LAYOUT_PADDING_WIDTH}px`}>
            <Header
              menuClose
              consoleHeader
              handleCloseMenu={() => null}
              tight={!isContextMenuOpened || isMaxWidth}
            />
          </Box>

          <Box className={contactSideMenuContainer}>
            <ContactSection />
            <SideMenuWrapper
              handleToggle={() => dispatch(toggleChatContextMenu(!isOpened))}
              handleSelectOption={(option: number) =>
                dispatch(selectChatContextMenuOption(option))
              }
              selectedOption={selectedOption}
              isOpen={isOpened}
              withChatBotHistoryOpt={currentContactChatHistory.chatbotHistory}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
